import { Configuration, PopupRequest } from "@azure/msal-browser";
import { environment } from "./environment";

/** Config object to be passed to Msal on creation */
export const msalConfig: Configuration = {
  auth: {
    clientId: environment.CLIENT_ID,
    authority: environment.AUTHORITY,
    redirectUri: environment.REDIRECT_URI,
    postLogoutRedirectUri: environment.POST_LOGOUT_REDIRECT_URI,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
    secureCookies: false,
  },
};

/** Scopes for the id token to be used at MS Identity Platform endpoints */
export const loginRequest: PopupRequest = {
  scopes: ["User.Read"],
};
